module.exports = __webpack_public_path__ + "static/media/tea-coffee.353ce33b.jpg";